<template><section><h1>Tab</h1>
<blockquote>
<p>标签栏</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td style="text-align:left">当前索引值，请使用v-model获取及设置</td>
<td><code>Number</code></td>
<td><code>0</code></td>
</tr>
<tr>
<td>data</td>
<td style="text-align:left">标签栏数据[<code>String</code> / <code>Object { name:标签名, icon:前置图标, suffix_icon:后置图标 }</code>]</td>
<td><code>Array</code></td>
<td>-</td>
</tr>
<tr>
<td>trigger</td>
<td style="text-align:left">标签切换事件触发类型, 可选值<code>click/hover</code></td>
<td><code>String</code></td>
<td><code>click</code></td>
</tr>
<tr>
<td>type</td>
<td style="text-align:left">标签类型，可选值<code>padding/no_padding/fix_width/fix_width:String</code></td>
<td><code>String</code></td>
<td><code>padding</code></td>
</tr>
<tr>
<td>width</td>
<td style="text-align:left">容器宽度</td>
<td><code>String/Number</code></td>
<td>-</td>
</tr>
<tr>
<td>height</td>
<td style="text-align:left">标签高度，可选值为 <code>Number / &quot;auto&quot;</code></td>
<td><code>String/Number</code></td>
<td><code>40</code></td>
</tr>
<tr>
<td>font_size</td>
<td style="text-align:left">字体大小</td>
<td><code>Number</code></td>
<td><code>14</code></td>
</tr>
<tr>
<td>gap</td>
<td style="text-align:left">标签之间的间隔</td>
<td><code>Number</code></td>
<td>-</td>
</tr>
<tr>
<td>theme</td>
<td style="text-align:left">标签主题，可选值<code>- /card/ticket</code></td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>active-style</td>
<td style="text-align:left">选中时标签样式</td>
<td><code>Object</code></td>
<td>-</td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>事件</th>
<th style="text-align:left">说明</th>
<th>参数</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td style="text-align:left">标签切换时，回调方法</td>
<td><code>[index &lt;Number:索引&gt;, title &lt;Any:选中标签名&gt;]</code></td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Tab.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-13.vue?07b46a96